import type { HistogramBucket, TermsBucket } from '../types/response'

export type TermsAggResult = {
	buckets: Array<TermsBucket>
	doc_count_error_upper_bound?: number
	sum_other_doc_count?: number
}

export type CommonValueEntry = {
	value: string
	count: number
	percent: number
}

/**
 * Dedupe histogram buckets by key and sort ascending.
 * Used when merging paged auto_date_histogram results.
 */
export function dedupeHistogramBuckets(
	buckets: ReadonlyArray<HistogramBucket>,
): Array<HistogramBucket> {
	const seen = new Map<number, HistogramBucket>()
	for (const bucket of buckets) {
		if (!seen.has(bucket.key)) seen.set(bucket.key, bucket)
	}
	return Array.from(seen.values()).sort((a, b) => a.key - b.key)
}

/**
 * Convert a terms-agg bucket list into `{value, count, percent}` rows.
 *
 * Percent is "share within the top N + other" — i.e. how much of the
 * shown population this row represents.
 */
export function bucketsToCommonValues(
	agg: TermsAggResult | undefined,
): Array<CommonValueEntry> {
	if (!agg) return []
	const total =
		agg.buckets.reduce((sum, b) => sum + b.doc_count, 0) +
		(agg.sum_other_doc_count ?? 0)
	if (total === 0) return []
	return agg.buckets.map((b) => ({
		value: b.key,
		count: b.doc_count,
		percent: b.doc_count / total,
	}))
}
